'use client';

import { CTA_POPUP_OPEN_EVENT, isHttpCtaUrl } from '@/utils/ctaPopup';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { Fragment, useEffect, useState } from 'react';

function hrefFromEvent(event) {
    const detail = event?.detail;
    if (typeof detail === 'string') return detail.trim();
    if (detail && typeof detail === 'object' && 'href' in detail) {
        return String(detail.href || '').trim();
    }
    return '';
}

export default function CtaPopupModal() {
    const [open, setOpen] = useState(false);
    const [src, setSrc] = useState('');

    useEffect(() => {
        const handleOpen = (event) => {
            const href = hrefFromEvent(event);
            if (!isHttpCtaUrl(href)) return;
            setSrc(href);
            setOpen(true);
        };

        window.addEventListener(CTA_POPUP_OPEN_EVENT, handleOpen);
        return () =>
            window.removeEventListener(CTA_POPUP_OPEN_EVENT, handleOpen);
    }, []);

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            className="relative z-[1400]"
        >
            <Transition
                show={open}
                as={Fragment}
                enter="transition-opacity ease-linear duration-200"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity ease-linear duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <Dialog.Overlay className="fixed inset-0 bg-black/60 backdrop-blur-sm" />
            </Transition>

            <div className="fixed inset-0 overflow-y-auto">
                <div className="flex min-h-[100dvh] items-center justify-center p-4">
                    <Transition
                        show={open}
                        as={Fragment}
                        enter="transition ease-out duration-200"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <Dialog.Panel className="relative w-full max-w-[720px] overflow-hidden rounded-[min(1.5rem,var(--shape-radius))] bg-white shadow-xl">
                            <button
                                type="button"
                                className="absolute right-3 top-3 z-10 inline-flex items-center justify-center rounded-full bg-white/90 p-2 text-neutral-700 shadow-sm hover:bg-neutral-100 focus:outline-none"
                                onClick={() => setOpen(false)}
                                aria-label="Close popup"
                            >
                                <XMarkIcon className="h-6 w-6" />
                            </button>
                            <div className="h-[min(741px,calc(100dvh-2rem))] w-full">
                                {src ? (
                                    <iframe
                                        src={src}
                                        title="CTA popup content"
                                        className="h-full w-full"
                                        loading="eager"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                                    />
                                ) : null}
                            </div>
                        </Dialog.Panel>
                    </Transition>
                </div>
            </div>
        </Dialog>
    );
}
